import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Redirect, useHistory, Link } from "react-router-dom";
import styles from "./ForgotPasswordV2.module.scss";
import { HeroImage } from "../LoginV2/HeroImage";
import logo from "../../public/logo.png";
import config from "../../config";
import { otpscreen } from "../../Redux/actions/actionCreator/data.action";
import { useTranslation } from "react-i18next";
import LanguageSelect from "../LanguageSelection";
import { DotLoader } from "../common/DotLoader";

export const ForgotPasswordV2 = () => {
  const [userid, setuserid] = useState("");
  const [loading, setloading] = useState(false);
  const [errr, setErr] = useState("");
  const [neterr, setneterr] = useState("");
  const [redirect, setredirect] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const handlesubmit = (event) => {
    event.preventDefault();
    let resok = true;
    console.log("Sending OTP...");

    if (userid === "") {
      console.log("email empty");
    } else {
      setloading(true);
      fetch(`${config.devurl}/daycareManager/sendOTP`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ username: userid.trimEnd() }),
      })
        .then((res) => {
          resok = res.ok;
          return res.json();
        })
        .then((data) => {
          console.log("data ", data);
          setErr("");
          setneterr("");
          if (resok) {
            console.log("data ", data);
            dispatch(otpscreen(data.DaycareManager));
            setTimeout(() => {
              setloading(false);
              setredirect("reset");
            }, 1000);
          } else {
            if (data.message) {
              setErr(data.message);
            } else {
              setErr(data.error);
            }
            setloading(false);
          }
        })
        .catch((error) => {
          setErr("");
          setloading(false);
          console.log("error", error);
          setneterr("Either Server out of reach or server internal error");
        });
    }
  };

  if (redirect === "reset") {
    return <Redirect to="/otp" />;
  }

  return (
    <div className={styles["forgot-password-container"]}>
      <div className={styles["hero-section"]}>
        <div className={styles.illustration}>
          <HeroImage />
        </div>
      </div>

      <div className={styles["form-section"]}>
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <LanguageSelect />
        </div>
        <div className={styles["form-container"]}>
          <div className={styles.logo}>
            <img
              src={logo}
              alt="Stepswatch logo"
              className={styles.logoImage}
            />
          </div>

          <h2 className={styles["welcome-title"]}>
            {t("forgotten_password")}
          </h2>
          <p className={styles.subtitle}>
            {t("forgot_password_subtitle")}
          </p>

          <form onSubmit={handlesubmit}>
            <div className={styles["form-group"]}>
              <label htmlFor="userId">{t("user_id")}</label>
              <input
                type="text"
                id="userId"
                onChange={(e) => setuserid(e.target.value)}
                value={userid}
                required
              />
            </div>

            {errr ? (
              <p className="alert11" style={{ color: "red" }}>
                {errr}
              </p>
            ) : null}
            {neterr ? <p style={{ color: "red" }}>{neterr}</p> : null}

            <div className={styles["form-footer"]}>
              <Link to="/login" className={styles["back-to-login"]}>
                {t("back_to_login")}
              </Link>
              <button
                type="submit"
                className={styles["submit-button"]}
                disabled={loading}
              >
                {loading ? <DotLoader /> : t("submit")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordV2;
